import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes, faMugSaucer } from '@fortawesome/free-solid-svg-icons'
import styles from './Menu.module.scss'

interface MenuIconProps {
  isMenuOpen: boolean
  handleMenuClick: () => void
}

const MenuIcon: React.FC<MenuIconProps> = ({ isMenuOpen, handleMenuClick }) => {
  return (
    <div className={styles.navIcon}>
      <div
        className={`${styles.menuIcon} ${
          isMenuOpen ? styles.menuOpen : styles.menuClosed
        }`}
        onClick={handleMenuClick}
      >
        <div className={styles.hamburger}>
          {isMenuOpen ? (
            <FontAwesomeIcon icon={faTimes} />
          ) : (
            <FontAwesomeIcon icon={faBars} />
          )}
        </div>
      </div>
      <a
        className={`${styles.support} ${styles.supportDesktop}`}
        href="https://www.buymeacoffee.com/languageguessr"
        target="_blank"
        rel="noreferrer"
      >
        <FontAwesomeIcon icon={faMugSaucer} />
        <p>Support this project!</p>
      </a>
    </div>
  )
}

export default MenuIcon
